import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";

import { ScreenContext } from "../..";

export function ScreenController({
  id,
  registerAtBottom,
  style,
  children,
  ...props
}) {
  const { store, dispatch } = useContext(ScreenContext);

  useEffect(() => {
    // registration is one-way by design: an unmount cleanup dispatch would
    // trip React 16's unmounted-update warning during whole-tree teardown.
    // Consumers disabling a conditional screen must unregister via
    // useScreenManager AND unmount the controller in the same render —
    // unregistering a still-mounted controller re-registers it here (and a
    // non-bottom screen would re-enter at the front).
    if (!(id in store.zMap))
      dispatch({
        type: "init-z-index",
        value: { screen: id, atBottom: registerAtBottom },
      });
  }, [id, registerAtBottom, store, dispatch]);

  return (
    <div
      {...props}
      style={{
        width: "inherit",
        height: "inherit",
        ...style,
        position: "absolute",
        zIndex: store.zMap[id]?.z,
      }}
    >
      {children}
    </div>
  );
}

ScreenController.propTypes = {
  id: PropTypes.string.isRequired,
  registerAtBottom: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node,
};
ScreenController.defaultProps = {
  registerAtBottom: false,
  style: {},
  children: null,
};

export default ScreenController;
